// src/components/ScrollToTopButton.jsx
import React, { useState, useEffect } from "react";
import { ChevronUp } from "lucide-react";

export default function ScrollToTopButton() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      setVisible(window.pageYOffset > 300); // 300px down を超えたら表示
    };
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  if (!visible) return null;
  return (
    <button
      onClick={scrollToTop}
      className="
        fixed bottom-8 right-8
        p-3 rounded-full shadow-lg
        bg-indigo-600 text-white
        hover:bg-indigo-700 transition-colors
        z-50
      "
    >
      <ChevronUp className="w-5 h-5" />
    </button>
  );
}
